import React from 'react';
import { PAGE } from 'placement/const';
import LastPageIcon from '@material-ui/icons/LastPage';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import { Pagination } from 'placement/domains';
import { ReferralPageAction } from 'placement/reducers/referralPage';
import { NavigationFilterValue } from '../domains/NavigationFilterService';
import { FilterBadges } from './FilterBadges';
import { MatchSubmitButton } from './MatchSubmitButton';
import { CommsToggleButton } from 'common';
import { useMyUnreadConversationCount } from 'offer/hook/useMyUnreadConversationCount';
import { FeatureFlagSwitch, ProviderPortalFeatureFlag } from 'featureflag';

type Props = {
    pagination: Pagination,
    page: PAGE,
    dispatch: React.Dispatch<ReferralPageAction>,
    filter: NavigationFilterValue,
    selectedOfferGuids: Array<string>,
    offerConversationOnly: boolean
}

export function ReferralListDetailBar({ pagination, filter, dispatch, page, selectedOfferGuids, offerConversationOnly }: Props) {
    const { count: unreadConversationCount } = useMyUnreadConversationCount();
    const toggleOfferConversationOnly = () => {
        dispatch({ type: 'TOGGLE_OFFER_CONVERSATION_ONLY' });
    };
    const startCursor = pagination.startCursor == null ? 0 : pagination.startCursor;
    const endCursor = pagination.endCursor == null ? 0 : pagination.endCursor;
    let lastPageCursor = Math.floor(pagination.total / pagination.pageSize) * pagination.pageSize
    if (lastPageCursor === pagination.total) {
        lastPageCursor = pagination.total - pagination.pageSize;
    }

    const nextPage = () => {
        if (pagination.hasNextPage) {
            dispatch({ type: 'SET_CURRENT_CURSOR', currentCursor: pagination.endCursor });
        }
    };
    const prevPage = () => {
        if (pagination.hasPreviousPage) {
            dispatch({ type: 'SET_CURRENT_CURSOR', currentCursor: (parseInt(pagination.startCursor) - pagination.pageSize).toString() });
        }
    };
    const firstPage = () => {
        if (pagination.hasPreviousPage) {
            dispatch({ type: 'SET_CURRENT_CURSOR', currentCursor: null });
        }
    };
    const lastPage = () => {
        if (pagination.hasNextPage) {
            dispatch({ type: 'SET_CURRENT_CURSOR', currentCursor: (lastPageCursor).toString() })
        }
    }

    return (
        <div className='pb-8'>
            <div className='w-full pb-2 flex px-3 justify-between'>
                <div className='flex items-center'>
                    <div className='text-xl flex-grow-0 font-semibold whitespace-no-wrap pr-10'>
                        {`${page.toString()} (${pagination.total})`}
                    </div>
                    <MatchSubmitButton  page={page} dispatch={dispatch} selectedOfferGuids={selectedOfferGuids}/>
                </div>
                <div className='flex items-center'>
                    {page === PAGE.PROVIDER_REQUEST && 
                    <FeatureFlagSwitch flag={ProviderPortalFeatureFlag.BHPNPP_3077_IS_TWO_WAY_MESSAGING_DISABLED} negate>
                        <div className='pr-4'>
                            <CommsToggleButton
                                active={offerConversationOnly}
                                unreadCount={unreadConversationCount}
                                onClick={toggleOfferConversationOnly}
                            />
                        </div>
                    </FeatureFlagSwitch>}
                    <div className='justify-end pt-2 items-start flex font-light text-sm text-gray-portal-table-title whitespace-no-wrap'>
                        <div>
                            {`${startCursor}-${endCursor} of ${pagination.total}`}
                        </div>
                        <div className='pl-5'>
                            <FirstPageIcon data-testid="first-page-nav" onClick={firstPage} />
                            <NavigateBeforeIcon data-testid="prev-page-nav" onClick={prevPage} />
                            <NavigateNextIcon data-testid="next-page-nav" onClick={nextPage} />
                            <LastPageIcon data-testid="last-page-nav" onClick={lastPage} />
                        </div>
                    </div>
                </div>
            </div>
            <div className='flex-grow'>
                <FilterBadges filter={filter} dispatch={dispatch} page={page}/>
            </div>
        </div>
    );
}
